import {Component, Inject, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

export interface ConfirmationModalInformation {
  title: string;
  info: string;
}

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmationModalComponent {
  modalTitle: string;
  actionMessage: string;
  warningMessage: string | null = null;
  modalInformation: Array<ConfirmationModalInformation>;
  confirmButton: string = 'Ok';
  constructor(
    private dialogRef: MatDialogRef<ConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) data: {
      modalTitle: string;
      actionMessage: string;
      warningMessage: string | null;
      modalInformation: Array<ConfirmationModalInformation>;
      confirmButton?:string;
    }
  ) {
    this.modalTitle = data.modalTitle;
    this.actionMessage = data.actionMessage;
    this.warningMessage = data.warningMessage;
    this.modalInformation = data.modalInformation;
    if(data.confirmButton){
     this.confirmButton = data.confirmButton;
    }
    dialogRef.disableClose = true;
  }
}
